<template>
  <div>
    <div class="mp-header-mobile px-5 py-5">
      <div class="header-item">
        <router-link
          tag="img"
          class="instacash-logo cursor-pointer"
          :src="require('@/assets/images/instacash-inner-logo.svg')"
          to="/profile"
        />
      </div>
      <div class="header-item">
        <b-dropdown v-if="countries" v-model="selectedCountryId" :mobile-modal="true" aria-role="list">
          <template v-if="selectedCountry" #trigger="{ active }">
            <button class="button is-small" outlined>
              <span v-html="getFlag(selectedCountry.flag)" class="flag"></span>
              <span>{{ selectedCountry.languageIso.split("-")[0] }}</span>
              <!-- <span>{{ selectedCountry.languageIso }}</span> -->
              <b-icon icon-pack="fa" :icon="active ? 'chevron-up' : 'chevron-down'" size="is-small"></b-icon>
            </button>
          </template>
    
          <b-dropdown-item v-for="country in countries" :key="country.id" :value="country.id" aria-role="listitem">
            <div class="country-list-item">
              <div v-html="getFlag(country.flag)" class="flag"></div>
              <div>{{ country.languageName }}</div>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <div class="header-item">
        <div @click="toggleHamburger">
          <b-icon
            class=""
            icon-pack="fas"
            icon="bars"
            type="is-white"
            size="is-medium"
          ></b-icon>
        </div>
      </div>
    </div>

    <transition name="slide">
      <div v-if="isHamburgerOpen" class="hamburger">
        <menu-content @click="toggleHamburger"></menu-content>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex/dist/vuex.common.js';
import twemoji from "@twemoji/api";

export default {
  name: "LoggedInHeaderMobile",
  components: {
    MenuContent: () => import("@/components/sidebar/MenuContent.vue"),
  },
  data() {
    return {
      isHamburgerOpen: false,
      selectedCountryId: null,
    };
  },
  computed: {
    ...mapGetters({
      countries: "i18n/countries",
      selectedCountry: "i18n/country",
    })
  },
  methods: {
    ...mapMutations({
      setCountryById: "i18n/setCountryById",
    }),
    toggleHamburger() {
      this.isHamburgerOpen = !this.isHamburgerOpen;
      if (this.isHamburgerOpen) {
        document.body.classList.add("hamburger-visible");
      } else {
        document.body.classList.remove("hamburger-visible");
      }
    },
    getFlag(flag) {
      if (flag) {
        return twemoji.parse(flag, {
          folder: "svg",
          ext: ".svg",
        });
      }
    },
  },
  watch: {
    selectedCountryId: {
      handler(newValue) {
        this.setCountryById(newValue);
      },
      // immediate: true,
    },
    selectedCountry: {
      handler(newValue) {
        this.selectedCountryId = newValue?.id;
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/colors.scss";

.mp-header-mobile {
  display: flex;
  height: 70px;
  width: 100%;
  background: $grey-dark;
  align-items: center;
  justify-content: space-between;

  .instacash-logo {
    height: 28px;
  }

  .header-item {
    display: flex;
    color: $white;
    flex: 1;
    gap: 1rem;
    justify-content: center;

    &:first-of-type {
      justify-content: flex-start;
    }
    &:last-of-type {
      justify-content: flex-end;
    }

    .button {
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      color: $white;
      height: 24px;
      padding: 0;
      background: none;
      border: none;
      gap: 5px;
      z-index: 1;

      &:focus {
        outline: none;
        box-shadow: none;
      }

      span {
        width: 18px;
      }

      .icon {
        margin: 0;
        width: 18px;
        height: 18px;

        svg {
          width: 10px;
          height: 10px;
        }
      }

      .flag {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        width: 18px;
        height: 18px;
      }
    }
  }
}

.country-list-item {
  display: flex;
  gap: 0.5rem;
  height: 24px;

  .flag {
    display: flex;
    align-items: center;
    width: 24px;
    height: 24px;
    font-size: 24px;
  }
}

::v-deep .menu-list {
  margin-left: 0;
  line-height: 3;
}

::v-deep .menu-item {
  margin-bottom: 0;
}

::v-deep .menu-icon {
  margin-left: 1rem;
}

::v-deep a.router-link-active {
  background: #0f2542 !important;
  color: $white;
  box-shadow: inset 4px 0 0 $primary;
}

.hamburger {
  position: absolute;
  z-index: 15;
  height: calc(100vh - 70px);
  top: 70px;
  left: 0;
  width: 100%;
  background: $grey-dark;
}

.slide-enter-active {
  transition-timing-function: ease-out;
  transition-duration: 0.2s;
  max-height: calc(100vh - 70px);
}
.slide-leave-active {
  transition-timing-function: ease-in;
  transition-duration: 0.2s;
  max-height: calc(100vh - 70px);
}

.slide-enter,
.slide-leave-to {
  max-height: 0;
}

@media only screen and (min-width: 769px) {
  .mp-header-mobile {
    display: none;
  }

  .hamburger {
    display: none !important;
    height: 0 !important;
  }
}
</style>

<style>
.hamburger-visible {
  position: fixed;
  width: 100%;
}
</style>
